var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKhotbaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 120,
    viewBox: "0 0 363 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2680_1689)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2680_1689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 0,
    width: 273,
    height: 91
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.029 0H45.7144V91H317.029V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2680_1689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2129 46.3426H65.4398L82.7037 24.6037H69.8962L53.2129 46.3426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.392 33.1914C114.274 33.1914 117.389 34.4856 119.734 37.0741C122.08 39.6221 123.253 43.1407 123.253 47.6301V67.4074H112.94V49.0254C112.94 46.7605 112.353 45.0012 111.18 43.7474C110.008 42.4936 108.43 41.8667 106.448 41.8667C104.467 41.8667 102.889 42.4936 101.716 43.7474C100.543 45.0012 99.957 46.7605 99.957 49.0254V67.4074H89.583V22.5141H99.957V38.1054C101.009 36.609 102.444 35.4159 104.264 34.5261C106.084 33.6363 108.127 33.1914 110.392 33.1914ZM163.889 33.5554V67.4074H153.515V62.7967C152.464 64.2932 151.028 65.5065 149.208 66.4367C147.429 67.3265 145.447 67.7714 143.263 67.7714C140.674 67.7714 138.389 67.2052 136.407 66.0727C134.426 64.8998 132.889 63.2214 131.797 61.0374C130.705 58.8534 130.159 56.2852 130.159 53.3327V33.5554H140.472V51.9374C140.472 54.2023 141.059 55.9616 142.231 57.2154C143.404 58.4692 144.982 59.0961 146.963 59.0961C148.986 59.0961 150.583 58.4692 151.756 57.2154C152.929 55.9616 153.515 54.2023 153.515 51.9374V33.5554H163.889ZM190.208 58.6107V67.4074H184.93C181.169 67.4074 178.237 66.4974 176.134 64.6774C174.031 62.8169 172.979 59.8038 172.979 55.6381V42.1701H168.854V33.5554H172.979V25.3048H183.353V33.5554H190.148V42.1701H183.353V55.7594C183.353 56.7705 183.596 57.4985 184.081 57.9434C184.566 58.3883 185.375 58.6107 186.508 58.6107H190.208ZM206.361 38.3481C207.332 36.7708 208.727 35.4968 210.547 34.5261C212.367 33.5554 214.449 33.0701 216.795 33.0701C219.586 33.0701 222.113 33.7779 224.378 35.1934C226.643 36.609 228.423 38.6312 229.717 41.2601C231.052 43.889 231.719 46.9425 231.719 50.4207C231.719 53.899 231.052 56.9727 229.717 59.6421C228.423 62.2709 226.643 64.3134 224.378 65.7694C222.113 67.1849 219.586 67.8927 216.795 67.8927C214.409 67.8927 212.327 67.4276 210.547 66.4974C208.767 65.5267 207.372 64.2527 206.361 62.6754V67.4074H195.987V22.5141H206.361V38.3481ZM221.163 50.4207C221.163 47.8323 220.435 45.8101 218.979 44.3541C217.563 42.8576 215.804 42.1094 213.702 42.1094C211.639 42.1094 209.88 42.8576 208.424 44.3541C207.008 45.8505 206.3 47.893 206.3 50.4814C206.3 53.0698 207.008 55.1123 208.424 56.6087C209.88 58.1052 211.639 58.8534 213.702 58.8534C215.764 58.8534 217.523 58.1052 218.979 56.6087C220.435 55.0718 221.163 53.0092 221.163 50.4207ZM235.1 50.4207C235.1 46.9425 235.747 43.889 237.041 41.2601C238.376 38.6312 240.175 36.609 242.44 35.1934C244.705 33.7779 247.233 33.0701 250.024 33.0701C252.41 33.0701 254.493 33.5554 256.272 34.5261C258.092 35.4968 259.488 36.7708 260.458 38.3481V33.5554H270.832V67.4074H260.458V62.6147C259.447 64.1921 258.032 65.4661 256.212 66.4367C254.432 67.4074 252.349 67.8927 249.963 67.8927C247.213 67.8927 244.705 67.1849 242.44 65.7694C240.175 64.3134 238.376 62.2709 237.041 59.6421C235.747 56.9727 235.1 53.899 235.1 50.4207ZM260.458 50.4814C260.458 47.893 259.73 45.8505 258.274 44.3541C256.859 42.8576 255.12 42.1094 253.057 42.1094C250.994 42.1094 249.235 42.8576 247.779 44.3541C246.363 45.8101 245.656 47.8323 245.656 50.4207C245.656 53.0092 246.363 55.0718 247.779 56.6087C249.235 58.1052 250.994 58.8534 253.057 58.8534C255.12 58.8534 256.859 58.1052 258.274 56.6087C259.73 55.1123 260.458 53.0698 260.458 50.4814ZM299.147 33.1914C303.03 33.1914 306.144 34.4856 308.49 37.0741C310.835 39.6221 312.008 43.1407 312.008 47.6301V67.4074H301.695V49.0254C301.695 46.7605 301.108 45.0012 299.936 43.7474C298.763 42.4936 297.185 41.8667 295.204 41.8667C293.222 41.8667 291.644 42.4936 290.472 43.7474C289.299 45.0012 288.712 46.7605 288.712 49.0254V67.4074H278.338V22.5141H288.712V38.1054C289.764 36.609 291.2 35.4159 293.02 34.5261C294.84 33.6363 296.882 33.1914 299.147 33.1914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8027 45.6685H66.0296L83.2935 67.4074H70.4861L53.8027 45.6685Z",
    fill: "url(#paint0_linear_2680_1689)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8908 29.4571C46.8031 29.7983 46.7588 30.1495 46.7592 30.5019C46.7592 30.8624 46.8051 31.2124 46.8908 31.5467H48.3786C48.3088 30.8519 48.3088 30.1519 48.3786 29.4571H46.8908ZM47.3181 28.4123H48.5437C48.6827 27.7765 48.8833 27.207 49.1293 26.7333C48.371 27.0988 47.74 27.6838 47.3181 28.4123ZM54.986 29.4571H53.4982C53.5681 30.1519 53.5681 30.8519 53.4982 31.5467H54.986C55.1619 30.8612 55.1619 30.1426 54.986 29.4571ZM54.5587 28.4123C54.1369 27.6838 53.5059 27.0988 52.7475 26.7333C52.9941 27.207 53.1942 27.7765 53.3331 28.4123H54.5587ZM49.4297 29.4571C49.3908 29.8041 49.3713 30.1527 49.3712 30.5019C49.3712 30.8597 49.3911 31.2098 49.4297 31.5467H52.4471C52.5257 30.8524 52.5257 30.1514 52.4471 29.4571H49.4297ZM49.6167 28.4123H52.2601C52.1649 28.0196 52.0278 27.6383 51.8511 27.2749C51.523 26.6194 51.1719 26.3226 50.9384 26.3226C50.7049 26.3226 50.3539 26.6194 50.0258 27.2749C49.8612 27.6051 49.7228 27.9891 49.6167 28.4123ZM47.3181 32.5915C47.74 33.32 48.371 33.905 49.1293 34.2705C48.8828 33.7968 48.6827 33.2274 48.5437 32.5915H47.3181ZM54.5587 32.5915H53.3331C53.1942 33.2274 52.9936 33.7968 52.7475 34.2705C53.5059 33.905 54.1369 33.32 54.5587 32.5915ZM49.6167 32.5915C49.7228 33.0147 49.8612 33.3986 50.0258 33.7289C50.3539 34.3844 50.7049 34.6812 50.9384 34.6812C51.1719 34.6812 51.523 34.3844 51.8511 33.7289C52.0156 33.3986 52.1541 33.0147 52.2601 32.5915H49.6167ZM50.9384 35.726C48.0532 35.726 45.7144 33.3871 45.7144 30.5019C45.7144 27.6167 48.0532 25.2778 50.9384 25.2778C53.8237 25.2778 56.1625 27.6167 56.1625 30.5019C56.1625 33.3871 53.8237 35.726 50.9384 35.726Z",
    fill: "url(#paint1_linear_2680_1689)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1625 42.1323C56.1625 39.2936 53.8613 36.9925 51.0226 36.9925C48.184 36.9925 45.8828 39.2936 45.8828 42.1323H56.1625ZM56.1625 67.4101V42.1323H45.8828V67.4101H56.1625Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349.521 105.575C353.539 105.575 356.737 106.887 359.115 109.511C361.534 112.094 362.744 115.661 362.744 120.212V140.261H352.289V121.627C352.289 119.331 351.694 117.547 350.505 116.276C349.316 115.005 347.717 114.37 345.708 114.37C343.699 114.37 342.1 115.005 340.911 116.276C339.722 117.547 339.128 119.331 339.128 121.627V140.261H328.611V105.944H339.128V110.495C340.194 108.978 341.629 107.789 343.433 106.928C345.237 106.026 347.266 105.575 349.521 105.575Z",
    fill: "url(#paint2_linear_2680_1689)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.674 140.754C301.312 140.754 298.278 140.036 295.572 138.601C292.907 137.166 290.795 135.116 289.237 132.451C287.72 129.786 286.962 126.67 286.962 123.103C286.962 119.577 287.741 116.482 289.299 113.817C290.857 111.111 292.989 109.04 295.695 107.605C298.401 106.17 301.435 105.453 304.797 105.453C308.159 105.453 311.193 106.17 313.899 107.605C316.605 109.04 318.737 111.111 320.295 113.817C321.853 116.482 322.632 119.577 322.632 123.103C322.632 126.629 321.832 129.745 320.233 132.451C318.675 135.116 316.523 137.166 313.776 138.601C311.07 140.036 308.036 140.754 304.674 140.754ZM304.674 131.652C306.683 131.652 308.384 130.914 309.778 129.438C311.213 127.962 311.931 125.85 311.931 123.103C311.931 120.356 311.234 118.245 309.84 116.769C308.487 115.293 306.806 114.555 304.797 114.555C302.747 114.555 301.045 115.293 299.692 116.769C298.339 118.204 297.663 120.315 297.663 123.103C297.663 125.85 298.319 127.962 299.631 129.438C300.984 130.914 302.665 131.652 304.674 131.652Z",
    fill: "url(#paint3_linear_2680_1689)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.804 102.378C273.959 102.378 272.442 101.844 271.253 100.779C270.105 99.6715 269.531 98.3185 269.531 96.7195C269.531 95.0795 270.105 93.7265 271.253 92.6605C272.442 91.5535 273.959 91 275.804 91C277.608 91 279.084 91.5535 280.232 92.6605C281.421 93.7265 282.016 95.0795 282.016 96.7195C282.016 98.3185 281.421 99.6715 280.232 100.779C279.084 101.844 277.608 102.378 275.804 102.378ZM281.032 105.945V140.262H270.515V105.945H281.032Z",
    fill: "url(#paint4_linear_2680_1689)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.257 131.344V140.261H258.907C255.094 140.261 252.121 139.339 249.989 137.494C247.857 135.608 246.791 132.553 246.791 128.33V114.677H242.609V105.944H246.791V97.5804H257.308V105.944H264.196V114.677H257.308V128.453C257.308 129.478 257.554 130.216 258.046 130.667C258.538 131.118 259.358 131.344 260.506 131.344H264.257Z",
    fill: "url(#paint5_linear_2680_1689)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.899 123.042C200.899 119.516 201.555 116.42 202.867 113.755C204.22 111.09 206.045 109.04 208.341 107.605C210.637 106.17 213.199 105.453 216.028 105.453C218.447 105.453 220.559 105.945 222.363 106.929C224.208 107.913 225.622 109.204 226.606 110.803V105.945H237.123V140.262H226.606V135.403C225.581 137.002 224.146 138.294 222.301 139.278C220.497 140.262 218.386 140.754 215.967 140.754C213.179 140.754 210.637 140.036 208.341 138.601C206.045 137.125 204.22 135.055 202.867 132.39C201.555 129.684 200.899 126.568 200.899 123.042ZM226.606 123.103C226.606 120.479 225.868 118.409 224.392 116.892C222.957 115.375 221.194 114.616 219.103 114.616C217.012 114.616 215.229 115.375 213.753 116.892C212.318 118.368 211.6 120.418 211.6 123.042C211.6 125.666 212.318 127.757 213.753 129.315C215.229 130.832 217.012 131.59 219.103 131.59C221.194 131.59 222.957 130.832 224.392 129.315C225.868 127.798 226.606 125.727 226.606 123.103Z",
    fill: "url(#paint6_linear_2680_1689)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.969 94.7515V140.261H184.453V94.7515H194.969Z",
    fill: "url(#paint7_linear_2680_1689)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.72 140.754C160.727 140.754 158.062 140.241 155.725 139.216C153.388 138.191 151.543 136.797 150.19 135.034C148.837 133.23 148.078 131.221 147.914 129.007H158.308C158.431 130.196 158.984 131.16 159.968 131.898C160.952 132.636 162.162 133.005 163.597 133.005C164.909 133.005 165.913 132.759 166.61 132.267C167.348 131.734 167.717 131.057 167.717 130.237C167.717 129.253 167.205 128.536 166.18 128.085C165.155 127.593 163.494 127.06 161.198 126.486C158.738 125.912 156.688 125.317 155.048 124.702C153.408 124.046 151.994 123.042 150.805 121.689C149.616 120.295 149.021 118.429 149.021 116.092C149.021 114.124 149.554 112.341 150.62 110.742C151.727 109.102 153.326 107.81 155.417 106.867C157.549 105.924 160.071 105.453 162.982 105.453C167.287 105.453 170.669 106.519 173.129 108.651C175.63 110.783 177.065 113.612 177.434 117.138H167.717C167.553 115.949 167.02 115.006 166.118 114.309C165.257 113.612 164.109 113.263 162.674 113.263C161.444 113.263 160.501 113.509 159.845 114.001C159.189 114.452 158.861 115.088 158.861 115.908C158.861 116.892 159.374 117.63 160.399 118.122C161.465 118.614 163.105 119.106 165.319 119.598C167.861 120.254 169.931 120.91 171.53 121.566C173.129 122.181 174.523 123.206 175.712 124.641C176.942 126.035 177.578 127.921 177.619 130.299C177.619 132.308 177.045 134.112 175.897 135.711C174.79 137.269 173.17 138.499 171.038 139.401C168.947 140.303 166.508 140.754 163.72 140.754Z",
    fill: "url(#paint8_linear_2680_1689)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.829 105.575C132.847 105.575 136.045 106.887 138.423 109.511C140.842 112.094 142.051 115.661 142.051 120.212V140.261H131.596V121.627C131.596 119.331 131.002 117.547 129.813 116.276C128.624 115.005 127.025 114.37 125.016 114.37C123.007 114.37 121.408 115.005 120.219 116.276C119.03 117.547 118.435 119.331 118.435 121.627V140.261H107.919V105.944H118.435V110.495C119.501 108.978 120.936 107.789 122.74 106.928C124.544 106.026 126.574 105.575 128.829 105.575Z",
    fill: "url(#paint9_linear_2680_1689)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.687 123.042C63.687 119.516 64.343 116.42 65.655 113.755C67.008 111.09 68.8325 109.04 71.1285 107.605C73.4245 106.17 75.987 105.453 78.816 105.453C81.235 105.453 83.3465 105.945 85.1505 106.929C86.9955 107.913 88.41 109.204 89.394 110.803V105.945H99.9105V140.262H89.394V135.403C88.369 137.002 86.934 138.294 85.089 139.278C83.285 140.262 81.1735 140.754 78.7545 140.754C75.9665 140.754 73.4245 140.036 71.1285 138.601C68.8325 137.125 67.008 135.055 65.655 132.39C64.343 129.684 63.687 126.568 63.687 123.042ZM89.394 123.103C89.394 120.479 88.656 118.409 87.18 116.892C85.745 115.375 83.982 114.616 81.891 114.616C79.8 114.616 78.0165 115.375 76.5405 116.892C75.1055 118.368 74.388 120.418 74.388 123.042C74.388 125.666 75.1055 127.757 76.5405 129.315C78.0165 130.832 79.8 131.59 81.891 131.59C83.982 131.59 85.745 130.832 87.18 129.315C88.656 127.798 89.394 125.727 89.394 123.103Z",
    fill: "url(#paint10_linear_2680_1689)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5888 111.664C50.8188 109.778 52.3563 108.302 54.2013 107.236C56.0463 106.129 58.0963 105.575 60.3513 105.575V116.707H57.4608C54.8368 116.707 52.8688 117.281 51.5568 118.429C50.2448 119.536 49.5888 121.504 49.5888 124.333V140.261H39.0723V105.944H49.5888V111.664Z",
    fill: "url(#paint11_linear_2680_1689)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3945 97.0885V105.514H21.9555V140.262H11.439V105.514H0V97.0885H33.3945Z",
    fill: "url(#paint12_linear_2680_1689)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2680_1689",
    x1: 68.5481,
    y1: 45.6685,
    x2: 68.5481,
    y2: 67.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2680_1689",
    x1: 50.9384,
    y1: 25.2778,
    x2: 50.9384,
    y2: 35.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2680_1689",
    x1: -4.17597,
    y1: 72.2614,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2680_1689",
    x1: -4.176,
    y1: 72.2615,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2680_1689",
    x1: -4.17553,
    y1: 72.2615,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2680_1689",
    x1: -4.17613,
    y1: 72.2614,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2680_1689",
    x1: -4.1759,
    y1: 72.2615,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2680_1689",
    x1: -4.17554,
    y1: 72.2615,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2680_1689",
    x1: -4.1759,
    y1: 72.2615,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2680_1689",
    x1: -4.17576,
    y1: 72.2614,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2680_1689",
    x1: -4.17594,
    y1: 72.2615,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2680_1689",
    x1: -4.17599,
    y1: 72.2614,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2680_1689",
    x1: -4.17583,
    y1: 72.2615,
    x2: 372.841,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F7AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#49B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758FE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2680_1689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 363,
    height: 141,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhotbaLogo);
export default __webpack_public_path__ + "static/media/khotba_logo.1883adfee05dd598065d5e662f25412f.svg";
export { ForwardRef as ReactComponent };